import React, { useEffect, useState } from "react";
import ScoreMemberCard from "../ScoreItem/ScoreMemberCard";
import PillIcon from "../../../../Images/Icons/Pill Icon.png";
import { getVideoUrlAsync } from "../../../../Services/VideoService";
import MedicalModuleDescription from "../../../../Pages/PartnerModules/MedicalModuleDescription";
import { IRecipientModel } from "../../../../Models/Recipient";
import ModuleOverviewModal from "../../../../Pages/PartnerModules/ModuleOverviewModal";
import TaskList from "../../../Assessment/TaskList/TaskList";
import TaskModal from "../ModuleTasks/ModuleModal/TaskModal";
import { observer } from "mobx-react-lite";
import { moduleTitles } from "../../../Enums/TitleEnums"

export interface IMedicalScoreCardProps {
  selectedRecipient: IRecipientModel;
  caregiverId: string;
}

export const MedicalScoreCard: React.FC<IMedicalScoreCardProps> = ({
  selectedRecipient, caregiverId
}) => {
  const [MedicalDomainIntroductionVideo, setMedicalDomainIntroductionVideo] = useState("");
  const [moduleOverviewVisible, setModuleOverviewVisible] = useState(false);
  const [taskAssessmentVisible, setTaskAssessmentVisible] = useState(false);
  const [taskChecklistVisible, setTaskChecklistVisible] = useState(false);
  const [taskIndex, setTaskIndex] = useState(0);
  const [taskTitle, setTaskTitle] = useState(selectedRecipient.medicalAssessment.questions[0].taskName || "");

  useEffect(() => {
    getVideoUrlAsync().then((url) => {
      setMedicalDomainIntroductionVideo(url);
    });
  }, []);

  const setOverviewVisible = () => { setModuleOverviewVisible(true); };
  const setIndexOfTask = (idx: number) => { setTaskIndex(idx); };
  const setTitleOfTask = (title: string) => { setTaskTitle(title); }

  const questions = selectedRecipient.medicalAssessment.questions;

  const renderModuleOverview = () => {
    return (
      <ModuleOverviewModal
        overviewBody={<MedicalModuleDescription />}
        hideOverview={() => setModuleOverviewVisible(false)}
        tasks={questions}
        assessment={selectedRecipient.medicalAssessment}
        domain={moduleTitles.MEDICAL}
        taskIndex={taskIndex}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        setTaskChecklistToVisible={() => setTaskChecklistVisible(true)}
        setAssessmentToVisible={() => setTaskAssessmentVisible(true)}
        setAssessmentHidden={() => setTaskAssessmentVisible(false)}
        setTaskIndex={setIndexOfTask}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskModal = () => {
    return (
      <TaskModal
        hideAssessment={() => setTaskAssessmentVisible(false)}
        taskIndex={taskIndex}
        taskTitle={taskTitle}
        recipient={selectedRecipient}
        assessment={selectedRecipient.medicalAssessment}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        domain={moduleTitles.MEDICAL}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskChecklistModal = () => {
    return (
      <TaskList
        assessment={selectedRecipient.medicalAssessment}
        hideTaskList={() => setTaskChecklistVisible(false)}
      />
    );
  };

  return (
    <>
      {taskChecklistVisible && renderTaskChecklistModal()}
      {taskAssessmentVisible && renderTaskModal()}
      {moduleOverviewVisible && renderModuleOverview()}
      <ScoreMemberCard
        percentComplete={selectedRecipient.medicalScoreComplete}
        selectedRecipient={selectedRecipient}
        icon={PillIcon}
        title={moduleTitles.MEDICAL}
        videoLink={MedicalDomainIntroductionVideo}
        overviewTitle="Medical Overview"
        overviewBody={<MedicalModuleDescription />}
        assessment={selectedRecipient.medicalAssessment}
        tasks={[]}
        setModVisible={setOverviewVisible}
        setAssessmentVisible={setOverviewVisible}
      />
    </>
  );
};

export default observer(MedicalScoreCard);
